import React from "react";
import "./About_Us.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Tab_list from "../Common/Common_Component/Tab_list/Tab_list";

function About_Us() {
     const tabListData = [
    {
      type: "link",
      name: "Confidentiality Agreement",
      image: "/assets/images/icons/invitation_code.png",
         link: "/confidentiality-agreement",
    },
    {
      type: "link",
      name: "Risk Disclosure Agreement",
      image: "/assets/images/icons/invitation_rule.png",
      link: "/risk-disclosure-agreement",
    },
    
  ];
  return (
    <>
      <section className="About_Us">
        <Common_white_header headingText={"About Us"} />
        <div className="container">
          <div className="banner_img_holder">
            <img
              className="banner_img"
              src="/assets/images/about_us/banner/img_1.png"
              alt="banner"
            />
          </div>

          <Tab_list listItems={tabListData} />


        </div>
      </section>
    </>
  );
}

export default About_Us;
